import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { isLoggedIn } from '../data';
import HomeIcon from '@material-ui/icons/Home';
import PersonIcon from '@material-ui/icons/Person';
import IconButton from '@material-ui/core/IconButton';
import PolicyIcon from '@material-ui/icons/Policy';

const useStyles = (theme) => ({
    root: {
        marginBottom: theme.spacing(1),
    },
    menuButton: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        display: 'inline-flex',
        alignSelf: 'center',
    },
    title: {
        flexGrow: 1,
        alignSelf: 'center',
    },
    bottomBar: {
        top: 'auto',
        bottom: 0,
    },
    "@media (min-width: 1280px)": {
        bottomBar: {
            maxWidth: 700,
            left: '50%',
            transform: 'translateX(-50%)',
        },
    },
    bottomBarItemHolder: {
        marginTop: theme.spacing(1),
        display: 'flex',
        alignSelf: 'center',
    },
    bottomBarItems: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        alignSelf: 'center',
    },
});

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: undefined,
            isLoggedIn: false,
        };
        this.title = 'CricketPattinam';
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    async componentDidMount() {
        var self = this;
        const recognized = await isLoggedIn();
        self.setState(() => ({
            ...self.state,
            isLoggedIn: recognized,
        }));
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                        <Link to={'/'} style={{color: '#fff', textDecorationLine: 'none'}}>
                            {this.title}
                        </Link>
                        </Typography>
                    </Toolbar>
                </AppBar>
                <AppBar position="fixed" className={classes.bottomBar}>
                    <div className={classes.bottomBarItemHolder}>
                        <Link to={'/'} className={classes.bottomBarItems}>
                            <IconButton>
                                <HomeIcon color='action' />
                            </IconButton>
                        </Link>
                        <Link to={'/profile'} className={classes.bottomBarItems}>
                            <IconButton>
                                <PersonIcon color='action' />
                            </IconButton>
                        </Link>
                        <Link to={'/privacy'} className={classes.bottomBarItems}>
                            <IconButton>
                                <PolicyIcon color='action' />
                            </IconButton>
                        </Link>
                    </div>
                </AppBar>
            </div>
        );
    }
}

export default withStyles(useStyles)(Navbar);